import { StreamEvent } from '@/types/streams/event'

export const getTranscoder = (event: StreamEvent, backup: boolean) => {
  const { tournament, preferedZixiServer, preferedBackupZixiServer, streamingConfig } = event
  if (backup) {
    return (
      (streamingConfig && streamingConfig.backupZixiServer) ||
      preferedBackupZixiServer ||
      tournament.preferedBackupZixiServer
    )
  }
  return (
    (streamingConfig && streamingConfig.zixiServer) ||
    preferedZixiServer ||
    tournament.preferedZixiServer
  )
}

export const hasDirectConnect = (event: StreamEvent) => {
  const { tournament, directConnect } = event
  if (!tournament) return false
  const followTournament = directConnect === 'FOLLOW_TOURNAMENT'
  return directConnect === 'YES' || (followTournament && tournament.directConnect === 'YES')
}

export const getTranscoderLabel = (event: StreamEvent, backup: boolean) => {
  const transcoder = getTranscoder(event, backup)

  if (!transcoder) {
    return 'Auto'
  }

  const { privateIp, hostname, ip, region } = transcoder
  const privateLabel = hasDirectConnect(event) ? ` - ${privateIp}` : ''

  return `${hostname || ip}${privateLabel} (${region})`
}

export const getDVRStatus = (event: StreamEvent) => {
  const eventDVR = event.dvr
  const eventHasDVRAuto = eventDVR === -1
  const dvrWindow = eventHasDVRAuto ? event.tournament.dvr : eventDVR
  if (dvrWindow > 0) {
    return `On (${dvrWindow / 60 / 60} hours)`
  } else {
    return 'Off'
  }
}

export const hasTranscoderRedundancy = (event: StreamEvent) => {
  const { tournament, transcoderRedundancy } = event
  if (!tournament) return false
  const followTournament = transcoderRedundancy === 'FOLLOW_TOURNAMENT'
  return transcoderRedundancy === 'ON' || (followTournament && tournament.useTranscoderRedundancy)
}

export const isUsingBackupTranscoder = (event: StreamEvent) => {
  return (
    hasTranscoderRedundancy(event) && (!event.isCombiner || event.streamingConfig?.backupZixiServer)
  )
}
